/**
 * base64url both ways: subscribe() wants raw bytes, and the subscribe endpoint wants base64url back.
 *
 * The encoder is also the rotation check. A subscription made against an old public key is one the new
 * private key cannot sign for, and that shows up only as a 403 the server-side pruning never clears.
 */

const BASE64URL_TO_BASE64 = /[-_]/g;
const REPLACEMENTS: Readonly<Record<string, string>> = { '-': '+', _: '/' };

export function vapidKeyToBytes(base64Url: string): Uint8Array<ArrayBuffer> {
  const padding = '='.repeat((4 - (base64Url.length % 4)) % 4);
  const base64 = (base64Url + padding).replace(BASE64URL_TO_BASE64, (character) => REPLACEMENTS[character]);
  const raw = atob(base64);
  const bytes = new Uint8Array(new ArrayBuffer(raw.length));
  for (let index = 0; index < raw.length; index++) {
    bytes[index] = raw.charCodeAt(index);
  }
  return bytes;
}

export function bytesToBase64Url(buffer: ArrayBuffer | null): string {
  if (!buffer) {
    return '';
  }

  const bytes = new Uint8Array(buffer);
  let raw = '';
  for (const byte of bytes) {
    raw += String.fromCharCode(byte);
  }
  return btoa(raw).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
